<script>
import { Helper } from '@/mixin/helper'
import { MixPanel } from '@/mixin/mixpanel'

export default {
  mixins: [Helper, MixPanel],
  props: {
    title: {
      type: String,
      default: '',
    },

    list: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      screenWidth: window.innerWidth,
      defaultImage: require('@/assets/images/default-image-user.png'),
    }
  },
  computed: {
    productList() {
      this.list.forEach((product) => {
        const matchedCategory = this.categoryList.find(
          (category) => category.id === product.product_category_id
        )
        if (matchedCategory) {
          const parentCategory = this.categoryList.find(
            (category) => category.id === matchedCategory.parent_id
          )
          if (parentCategory) {
            product.subcategory = matchedCategory.name
            product.category = parentCategory.name
          } else {
            product.category = matchedCategory.name
          }
        }
      })
      return this.list
    },
    categoryList() {
      return this.$store.state.marketplace.categories
    },
  },
  methods: {
    openDetailPage(moreLink, productName, categoryName) {
      // Redirect ke halaman detail dengan more_link sebagai query parameter
      this.track('Click Marketplace Product Detail', {
        productName: productName,
      })
      this.$router.push({
        name: 'Marketplace Product Detail',
        query: { externalLink: moreLink, productName: productName, category: categoryName },
      })
    },
    openContactUsPage(contactPageURL, productName) {
      this.track('Click Marketplace Contact Us', {
        productName: productName,
      })
      window.open(contactPageURL, '_blank')
    },
  },
}
</script>

<template>
  <div>
    <b-card :title="title">
      <b-row v-if="productList.length > 0" class="mt-4">
        <b-col
          v-for="product in productList"
          :key="product.id"
          xl="3"
          lg="6"
          md="6"
          class="mc-marketplace-box"
        >
          <b-card class="border border-1">
            <b-row class="mb-2">
              <b-col class="mb-1" md="3">
                <figure class="mb-0">
                  <img
                    class="mc-marketplace-box__items-img"
                    :src="product.image ? product.image : defaultImage"
                    alt
                  />
                </figure>
              </b-col>
              <b-col md="9">
                <h5 class="mc-general__label mc-marketplace-box__items-name">
                  {{ product.name }}
                </h5>
              </b-col>
            </b-row>
            <div v-if="product.subcategory" class="mb-2">
              <span class="mc-marketplace-box__items-tag me-2">
                {{ product.subcategory }}
              </span>
            </div>
            <p class="mc-general__label mc-marketplace-box__items-desc">
              {{ product.description }}
            </p>

            <!-- Buttons positioned at the bottom-right corner -->
            <div class="mc-marketplace-box__items-btn-position">
              <button
                v-if="product.more_link"
                class="mc-marketplace-box__items-btn me-2"
                @click="openDetailPage(product.more_link, product.name, product.category)"
              >
                {{ $t('marketplace.product.viewMore') }}
              </button>
              <button
                v-if="product.chat_link"
                class="mc-marketplace-box__items-btn mc-marketplace-box__items-btn--primary"
                @click="openContactUsPage(product.chat_link, product.name)"
              >
                {{ $t('marketplace.product.contactUs') }}
              </button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-else class="mt-4">
        <h5 class="text-center">
          {{ $t('global.text.noData') }}
        </h5>
      </b-row>
    </b-card>
  </div>
</template>
